import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
import usePermissions from '@/hooks/use-permissions';
import useSession from '@/hooks/use-session';
import { isAgentsTabAccessible } from '@/utils/agents-access';
import MenuDropdown, { type MenuLink } from '../menu-dropdown';
export type SettingsDropdownProps = {
  href: string;
  text: string;
  icon: Icon;
  isCollapsed: boolean;
  pathname: string;
};
const SettingsDropdown = t0 => {
  const $ = _c(49);
  const {
    href,
    text,
    icon: Icon,
    isCollapsed,
    pathname
  } = t0;
  const {
    t
  } = useTranslation("settings");
  const {
    data: t1
  } = useSession();
  const {
    user,
    org
  } = t1;
  const {
    isAdmin,
    isAuditor
  } = usePermissions();
  const shouldShowBilling = org?.id === "org_AiK8peOw9mrqsb6yeHWEG8" && isAdmin || user?.isFirmEmployee;
  let t2;
  bb0: {
    const t3 = `${href}/feature-previews`;
    let t4;
    if ($[0] !== t) {
      t4 = t(_temp);
      $[0] = t;
      $[1] = t4;
    } else {
      t4 = $[1];
    }
    let t5;
    if ($[2] !== t3 || $[3] !== t4) {
      t5 = {
        href: t3,
        text: t4
      };
      $[2] = t3;
      $[3] = t4;
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    const previewLink = t5;
    if (isAuditor) {
      let t6;
      if ($[5] !== previewLink) {
        t6 = [previewLink];
        $[5] = previewLink;
        $[6] = t6;
      } else {
        t6 = $[6];
      }
      t2 = t6;
      break bb0;
    }
    const t6 = `${href}/business-profile`;
    let t7;
    if ($[7] !== t) {
      t7 = t(_temp2);
      $[7] = t;
      $[8] = t7;
    } else {
      t7 = $[8];
    }
    let t8;
    if ($[9] !== t6 || $[10] !== t7) {
      t8 = {
        href: t6,
        text: t7
      };
      $[9] = t6;
      $[10] = t7;
      $[11] = t8;
    } else {
      t8 = $[11];
    }
    const t9 = `${href}/team-roles`;
    let t10;
    if ($[12] !== t) {
      t10 = t(_temp3);
      $[12] = t;
      $[13] = t10;
    } else {
      t10 = $[13];
    }
    let t11;
    if ($[14] !== t10 || $[15] !== t9) {
      t11 = {
        href: t9,
        text: t10
      };
      $[14] = t10;
      $[15] = t9;
      $[16] = t11;
    } else {
      t11 = $[16];
    }
    const t12 = `${href}/statuses`;
    let t13;
    if ($[17] !== t) {
      t13 = t(_temp4);
      $[17] = t;
      $[18] = t13;
    } else {
      t13 = $[18];
    }
    let t14;
    if ($[19] !== t12 || $[20] !== t13) {
      t14 = {
        href: t12,
        text: t13
      };
      $[19] = t12;
      $[20] = t13;
      $[21] = t14;
    } else {
      t14 = $[21];
    }
    let links;
    if ($[22] !== href || $[23] !== shouldShowBilling || $[24] !== t || $[25] !== t11 || $[26] !== t14 || $[27] !== t8 || $[28] !== user) {
      links = [t8, t11, t14];
      if (isAgentsTabAccessible({
        user
      })) {
        const t15 = `${href}/browser`;
        let t16;
        if ($[30] !== t) {
          t16 = t(_temp5);
          $[30] = t;
          $[31] = t16;
        } else {
          t16 = $[31];
        }
        let t17;
        if ($[32] !== t15 || $[33] !== t16) {
          t17 = {
            href: t15,
            text: t16
          };
          $[32] = t15;
          $[33] = t16;
          $[34] = t17;
        } else {
          t17 = $[34];
        }
        links.push(t17);
      }
      if (shouldShowBilling) {
        const t15 = `${href}/billing`;
        let t16;
        if ($[35] !== t) {
          t16 = t(_temp6);
          $[35] = t;
          $[36] = t16;
        } else {
          t16 = $[36];
        }
        let t17;
        if ($[37] !== t15 || $[38] !== t16) {
          t17 = {
            href: t15,
            text: t16
          };
          $[37] = t15;
          $[38] = t16;
          $[39] = t17;
        } else {
          t17 = $[39];
        }
        links.push(t17);
      }
      $[22] = href;
      $[23] = shouldShowBilling;
      $[24] = t;
      $[25] = t11;
      $[26] = t14;
      $[27] = t8;
      $[28] = user;
      $[29] = links;
    } else {
      links = $[29];
    }
    let t15;
    if ($[40] !== links || $[41] !== previewLink) {
      t15 = [...links, previewLink];
      $[40] = links;
      $[41] = previewLink;
      $[42] = t15;
    } else {
      t15 = $[42];
    }
    t2 = t15;
  }
  const subLinks = t2;
  let t3;
  if ($[43] !== Icon || $[44] !== isCollapsed || $[45] !== pathname || $[46] !== subLinks || $[47] !== text) {
    t3 = <MenuDropdown text={text} icon={Icon} isCollapsed={isCollapsed} subLinks={subLinks} pathname={pathname} />;
    $[43] = Icon;
    $[44] = isCollapsed;
    $[45] = pathname;
    $[46] = subLinks;
    $[47] = text;
    $[48] = t3;
  } else {
    t3 = $[48];
  }
  return t3;
};
export default SettingsDropdown;
function _temp($) {
  return $.pages.featurePreviews.title;
}
function _temp2($_0) {
  return $_0.pages.businessProfile.title;
}
function _temp3($_1) {
  return $_1.pages.teamRoles.title;
}
function _temp4($_2) {
  return $_2.pages.statuses.title;
}
function _temp5($_3) {
  return $_3.pages.browser.title;
}
function _temp6($_4) {
  return $_4.pages.billing.title;
}